"use strict";
/* tslint:disable: variable-name no-shadowed-variable */
Object.defineProperty(exports, "__esModule", { value: true });
var P_t = 0.000611657 * 1000 * 1000; // [MPa] -> [Pa]
var T_t = 273.16; // [K]
/// <param name="T">Temperature [K]</param>
/// <returns>Water Vapor Sublimation Pressure [Pa]</returns>
function Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium(T) {
    var theta = T / T_t;
    var p_ws = P_t * Math.exp(Math.pow(theta, -1) * (-0.212144006E2 * Math.pow(theta, 0.333333333E-2) +
        0.273203819E2 * Math.pow(theta, 0.120666667E1) -
        0.610598130E1 * Math.pow(theta, 0.170333333E1)));
    return p_ws;
}
exports.Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium = Get_Sublimation_Pressure_of_the_solid_vapor_equilibrium;
